import { GlobalResponseObject } from "../../../global-response-object";
import { RolesData } from "./roles-req";

export class AllRolesResponseModel extends GlobalResponseObject {
  data?: RolesData[];

  constructor(
    status: boolean,
    intlCode: number,
    internalMessage: string,
    data?: RolesData[]
  ) {
    super(status, intlCode, internalMessage);
    this.data = data;
  }
}
